'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _adminUserEditForm = require('./admin-user-edit-form.html');

var _adminUserEditForm2 = _interopRequireDefault(_adminUserEditForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _adminUserEditForm2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    user: '<',
    onUserChanged: '&'
  },
  controller: function () {
    function AdminUserEditFormComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, AdminUserEditFormComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(AdminUserEditFormComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.user = this.user || {};
      }
    }, {
      key: 'onSubmit',
      value: function onSubmit() {
        this.onUserChanged(this.EventEmitter({
          user: this.user
        }));
      }
    }]);

    return AdminUserEditFormComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/admin/admin-users/admin-user-edit-form/admin-user-edit-form.component.js